import { IonContent } from '@ionic/react';
import { useCallback, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';

import ResourceFeatureTemplateForm from '@components/forms/ResourceFeatureTemplateForm';
import AppPage from '@components/pageTypes/AppPage';

const ExpertResourceFeatureTemplateCreatePage = () => {
  const history = useHistory();
  const intl = useIntl();
  const contentRef = useRef<HTMLIonContentElement>(null);

  const handleFormCancelOrSuccess = () => history.push('/expert/resource-feature-templates');

  const handleFormError = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollToTop(2000);
    }
  }, [contentRef]);

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.expert.resourceFeatureTemplate.new' })}</title>
      </Helmet>
      <IonContent className="ion-padding" ref={contentRef}>
        <ResourceFeatureTemplateForm
          autofocus
          onCancel={handleFormCancelOrSuccess}
          onError={handleFormError}
          onSuccess={handleFormCancelOrSuccess}
        />
      </IonContent>
    </AppPage>
  );
};

export default ExpertResourceFeatureTemplateCreatePage;
